module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        Your order has encountered the following error in submission:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2",
    staticStyle: {
      "border": "3px solid red",
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetails.errorMessage) + "\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n       Your error has been saved as a pending-error order\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        If you believe you know the cause of the error you may edit the order \n        and try submitting it again. If you're not sure, the support team has \n        been notified of the error and will review the order in the next 2-3 business days. \n        This order can also be edited or deleted from the Track Order page at any time.\n        If this is an urgent order, please click "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ShowHelpForm()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to contact us.\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-260c4946", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260c4946"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderSubmit/OrderSubmitComponent/OrderError.vue
// module id = 474
// module chunks = 3